//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameMode, MAX_MULTIPLIERS ,GameStatus , BetType  } from './enum';

export default {
  name: 'LastWinsCard',
  props: {
    game: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isLg: false
    };
  },
  computed: {
    // 根据倍率判断卡片品质等级
    cardType() {
      if (!this.game || !this.game.ratio) {
        return 'normal';
      }

      const coef = parseFloat(this.game.ratio);

      if (coef >= 15) {
        return 'gold';
      } else if (coef >= 6) {
        return 'silver';
      } else if (coef >= 2.5) {
        return 'bronze';
      }

      return 'normal';
    },

    // 格式化展示数据
    displayData() {
      if (!this.game) {
        return {
          username: 'Katerpiller',
          user: null,
          itemName: 'Cinquedea',
          winAmount: '92.13',
          coefficient: '2.44',
          itemImage: '/assets/images/chicken-road/test-gun.webp',
          item: null
        };
      }

      const winItem = this.game.winItem || null;

      let winAmount = '0.00';
      if (this.game.winItemPrice) {
        winAmount = parseFloat(this.game.winItemPrice).toFixed(2);
      } else if (this.game.ratio && this.game.amount) {
        winAmount = (parseFloat(this.game.amount) * parseFloat(this.game.ratio)).toFixed(2);
      } else if (this.game.amount) {
        winAmount = parseFloat(this.game.amount).toFixed(2);
      }

      const coefficient = this.game.ratio
        ? parseFloat(this.game.ratio).toFixed(2)
        : '1.00';

      const username = this.game.user?.nickname || this.game.user?.username || 'Unknown';

      return {
        username,
        user: this.game.user,
        itemName: winItem?.name || 'Unknown',
        winAmount,
        coefficient,
        itemImage: winItem ? null : '/assets/images/chicken-road/test-gun.webp',
        item: winItem
      };
    },

    // 用户头像链接
    avatarUrl() {
      if (!this.displayData.user) return '';
      return this.$imgfilter(this.displayData.user.photoUrl) || require(`@/assets/images/user/ava_none.jpg`);
    },

    // 物品图片链接
    itemImgSrc() {
      if (this.displayData.itemImage) {
        return this.displayData.itemImage;
      }
      if (this.displayData.item) {
        return this.displayData.item.itemPic || '';
      }
      return '';
    },

    // 背景阴影素材路径
    shadowImgSrc() {
      if (this.cardType === 'normal') return '';

      const mobSuffix = this.isLg ? 'Mob' : '';
      return require(`./assets/${this.cardType}Shadow${mobSuffix}.webp`);
    }
  },
  mounted() {
    this.checkMediaQuery();
    window.addEventListener('resize', this.checkMediaQuery);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMediaQuery);
  },
  methods: {
    checkMediaQuery() {
      // 匹配移动端 lg 响应式断点 (992px)
      this.isLg = window.innerWidth <= 992;
    }
  }
};
